import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './InvitationAction.css';

function InvitationError() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const status = searchParams.get('status');

  const getErrorContent = () => {
    switch (error) {
      case 'not_found':
        return {
          icon: '🔍',
          title: 'Invitation Not Found',
          message: 'This invitation link is invalid or has been removed.',
          suggestion: 'Please check your email for the correct invitation link or contact the brand directly.'
        };
      case 'already_responded':
        return {
          icon: '✅',
          title: 'Already Responded',
          message: `You have already ${status === 'accepted' ? 'accepted' : status === 'rejected' ? 'declined' : 'responded to'} this invitation.`,
          suggestion: status === 'accepted' 
            ? 'Log in to your creator dashboard to view your campaign details.'
            : 'Check your email for other campaign invitations.'
        };
      case 'expired':
        return {
          icon: '⏰',
          title: 'Invitation Expired',
          message: 'This invitation has expired and is no longer available.',
          suggestion: 'Contact the brand if you are still interested in the campaign, or wait for new opportunities.'
        };
      case 'invalid':
      default:
        return {
          icon: '⚠️',
          title: 'Invalid Link',
          message: 'Something went wrong with this invitation link.',
          suggestion: 'Please try clicking the link from your email again, or contact support if the issue persists.'
        };
    }
  };

  const content = getErrorContent();

  return (
    <>
      <Navbar />
      <div className="invitation-action-page">
        <div className="invitation-card error">
          <div className="error-icon">{content.icon}</div>
          <h1>{content.title}</h1>
          <p>{content.message}</p>
          <p style={{ fontSize: '14px', color: '#64748b', marginBottom: '24px' }}>
            {content.suggestion}
          </p>
          <div className="result-actions">
            {error === 'already_responded' && status === 'accepted' ? (
              <a href="/login?type=creator" className="btn-primary">
                Go to Dashboard
              </a>
            ) : (
              <a href="/" className="btn-primary">
                Back to Home
              </a>
            )}
            <a href="mailto:support@milan-ai.net" className="btn-secondary">
              Contact Support
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default InvitationError;
